import { getTenantInfo } from '../../../../../backend-core-lib/app/common-shared/account/controllers/get-tenant-info';

export const apiEndpoints /*: ApiRequestConfigInfoDefinitionMap */ = {
  login: {
    endpoint: 'account/login',
    method: 'POST',
    sessionRequired: false,
  },
  loginMsal: {
    endpoint: 'account/login-msal',
    method: 'POST',
    sessionRequired: false,
  },
  forgotPassword: {
    endpoint: 'forgot-password',
    method: 'POST',
    sessionRequired: false,
  },
  resetPassword: {
    endpoint: 'reset-password',
    method: 'POST',
    sessionRequired: false,
  },
  session: {
    endpoint: 'session/info',
    method: 'GET',
    sessionRequired: true,
  },
  updateTenantInfoWikiUrl: {
    endpoint: 'tenant/info/wiki-url/{sectionId}',
    method: 'POST',
    sessionRequired: true,
  },

  deleteTenantInfoWikiUrl: {
    endpoint: 'tenant/info/wiki-url/{sectionId}',
    method: 'DELETE',
    sessionRequired: true,
  },

  linkTenant: {
    endpoint: 'tenant/link',
    method: 'POST',
    sessionRequired: true,
  },
  sessionTenants: {
    endpoint: 'session/tenants',
    method: 'GET',
    sessionRequired: true,
  },
  sessionTenantUsers: {
    endpoint: 'session/tenant-users',
    method: 'GET',
    sessionRequired: true,
  },
  powerAdminManagementTenants: {
    endpoint: 'power-mngt/tenants',
    method: 'GET',
    sessionRequired: true,
  },
  usersManagementTenantUsers: {
    endpoint: 'users-mngt/users',
    method: 'GET',
    sessionRequired: true,
  },
  usersManagementInviteUserToTenant: {
    endpoint: 'users-mngt/users/invite',
    method: 'POST',
    sessionRequired: true,
  },
  usersManagementAssignUsersRole: {
    endpoint: 'users-mngt/users/role/{scopeRoleId}/assign',
    method: 'POST',
    sessionRequired: true,
  },
  usersManagementRemoveUsersRole: {
    endpoint: 'users-mngt/users/role/{scopeRoleId}/remove',
    method: 'POST',
    sessionRequired: true,
  },

  settingsManagementGet: {
    endpoint: 'tenant/settings',
    method: 'GET',
    sessionRequired: true,
  },
  settingsManagementUpdate: {
    endpoint: 'tenant/settings',
    method: 'POST',
    sessionRequired: true,
  },
  getTenantInfo: {
    endpoint: 'tenant/info',
    method: 'GET',
    sessionRequired: true,
  },

  getEnvironments: {
    endpoint: 'environments?entityType={entityType}',
    method: 'GET',
    sessionRequired: true,
  },
  syncEnvironment: {
    endpoint: 'environments/{environmentUid}/sync?entityType={entityType}',
    method: 'GET',
    sessionRequired: true,
  },
  setEnvironmentFlag: {
    endpoint:
      'environments/{environmentUid}/entity/{entityType}/{entityId}/flag/{flagId}/set/{flagValue}',
    method: 'PUT',
    sessionRequired: true,
  },
  getEnvironmentUsers: {
    endpoint:
      'environments/{environmentUid}/entity/{entityType}/{entityId}/users',
    method: 'GET',
    sessionRequired: true,
  },
  deleteEnvironmentUser: {
    endpoint:
      'environments/{environmentUid}/entity/{entityType}/{entityId}/users/{userType}/{userId}',
    method: 'DELETE',
    sessionRequired: true,
  },
  addEnvironmentUser: {
    endpoint:
      'environments/{environmentUid}/entity/{entityType}/{entityId}/users/{userType}/{userId}',
    method: 'POST',
    sessionRequired: true,
  },

  confirmEntityActivity: {
    endpoint:
      'environments/{environmentUid}/entity/{entityType}/{entityId}/confirm-activity',
    method: 'PUT',
    sessionRequired: true,
  },

  getComplianceForm: {
    endpoint: 'compliance/forms',
    method: 'GET',
    sessionRequired: true,
  },
  addComplianceForm: {
    endpoint: 'compliance/forms',
    method: 'POST',
    sessionRequired: true,
  },
  updateComplianceForm: {
    endpoint: 'compliance/forms/{formId}',
    method: 'PUT',
    sessionRequired: true,
  },

  activateComplianceForm: {
    endpoint: 'compliance/forms/{formId}/activate',
    method: 'POST',
    sessionRequired: true,
  },
  inactivateComplianceForm: {
    endpoint: 'compliance/forms/{formId}/inactivate',
    method: 'POST',
    sessionRequired: true,
  },

  getEntityTypeCurrentComplianceForm: {
    endpoint: 'compliance/current/{entityType}',
    method: 'GET',
    sessionRequired: true,
  },
  getEntityTypeAllComplianceForms: {
    endpoint: 'compliance/all/{entityType}',
    method: 'GET',
    sessionRequired: true,
  },
  updateEntityComplianceForm: {
    endpoint:
      'compliance/filled-forms/{environmentUid}/{entityType}/{entityId}/compliance/form',
    method: 'POST',
    sessionRequired: true,
  },
  approveEntityComplianceForm: {
    endpoint:
      'compliance/filled-forms/{environmentUid}/{entityType}/{entityId}/compliance/form/approve',
    method: 'POST',
    sessionRequired: true,
  },
  getTenantNotifications: {
    endpoint: 'notifications/list/{category}?date={date}',
    method: 'GET',
    sessionRequired: true,
  },
  setTenantNotificationAsSeen: {
    endpoint: 'notifications/{notificationId}/seen',
    method: 'POST',
    sessionRequired: true,
  },
  getEmailAction: {
    endpoint: 'email-action/tenant/{tenantId}/action/{actionCode}',
    method: 'GET',
    sessionRequired: false,
  },
  sendEmailAction: {
    endpoint: 'email-action/tenant/{tenantId}/action/{actionCode}',
    method: 'POST',
    sessionRequired: false,
  },
  getDashboardData: {
    endpoint: 'dashboard-data',
    method: 'GET',
    sessionRequired: true,
  },
  getAuditLogsDay: {
    endpoint: 'audit-log/list/{day}',
    method: 'GET',
    sessionRequired: true,
  },
  getAuditLogsOverviewMonth: {
    endpoint: 'audit-log/overview/{month}',
    method: 'GET',
    sessionRequired: true,
  },
};
